import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-forest text-sage">
      {/* Main Footer */}
      <div className="container-main py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {/* Column 1 - Brand */}
          <div>
            <Link to="/" className="inline-block mb-5">
              <img
                src="https://static.wixstatic.com/media/34789f_37c0495c48eb453484cdf75935a43967~mv2.png"
                alt="SpinWorld.Us"
                className="w-[90px] md:w-[110px] h-auto"
              />
            </Link>
            <p className="text-base text-sage/80 leading-relaxed mb-6 font-sans">
              One of the largest selections of laser cut, stainless steel wind spinners in the USA. Rustproof, outdoor-ready, and built to last.
            </p>
            <div className="space-y-3 text-base text-sage/70 font-sans">
              <p className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5" />
                <span>5316 Trafalgar Place<br />Madison, WI 53714</span>
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-phone-line" />
                <a href="tel:907-500-8881" className="hover:text-white transition-colors">907-500-8881</a>
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-mail-line" />
                <a href="mailto:Spinworld@myyahoo.com" className="hover:text-white transition-colors">Spinworld@myyahoo.com</a>
              </p>
            </div>
            <div className="flex items-center gap-3 mt-5">
              <a href="https://www.facebook.com/alaskansartnaround/" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full border border-sage/30 flex items-center justify-center hover:border-copper hover:text-copper transition-colors" aria-label="Facebook">
                <i className="ri-facebook-fill text-sm" />
              </a>
              <a href="https://www.yelp.com/biz/alaskans-art-n-around-juneau" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full border border-sage/30 flex items-center justify-center hover:border-copper hover:text-copper transition-colors" aria-label="Yelp">
                <span className="text-xs font-bold">Y</span>
              </a>
            </div>
          </div>

          {/* Column 2 - Shop */}
          <div>
            <h5 className="text-base font-sans font-semibold uppercase tracking-label mb-6 text-white">Shop</h5>
            <ul className="space-y-3 font-sans">
              {[
                { name: 'Wind Spinners', path: '/collections/wind-spinners' },
                { name: 'Soapstone Animals', path: '/collections/soapstone-animals' },
                { name: 'Wire Wrapped Stones', path: '/collections/wire-wrapped-stones' },
                { name: 'Accessories', path: '/collections/accessories' },
                { name: 'Shop All', path: '/shop' },
              ].map((link) => (
                <li key={link.name}>
                  <Link to={link.path} className="text-base text-sage/70 hover:text-white transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3 - Company */}
          <div>
            <h5 className="text-base font-sans font-semibold uppercase tracking-label mb-6 text-white">Company</h5>
            <ul className="space-y-3 font-sans">
              {[
                { name: 'About', path: '/about' },
                { name: 'Contact', path: '/contact' },
                { name: 'FAQ', path: '/contact' },
              ].map((link) => (
                <li key={link.name}>
                  <Link to={link.path} className="text-base text-sage/70 hover:text-white transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4 - Policies */}
          <div>
            <h5 className="text-base font-sans font-semibold uppercase tracking-label mb-6 text-white">Policies</h5>
            <ul className="space-y-3 font-sans">
              {[
                { name: 'Shipping Policy', path: '/shipping-policy' },
                { name: 'Returns & Refunds', path: '/returns-refunds' },
                { name: 'Privacy Policy', path: '/privacy-policy' },
                { name: 'Terms & Conditions', path: '/terms-conditions' },
              ].map((link) => (
                <li key={link.name}>
                  <Link to={link.path} className="text-base text-sage/70 hover:text-white transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright Bar */}
      <div className="border-t border-sage/20">
        <div className="container-main py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-sage/60 font-sans">
          <p>
            &copy; 2026 SpinWorld.Us &middot; All rights reserved
          </p>
          <p>
            Designed and Powered by{' '}
            <a href="https://www.kalamazoowebsitedesign.com" target="_blank" rel="noopener noreferrer" className="text-sage hover:text-white transition-colors">
              Kalamazoo Website Design
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}